import React, { Component } from "react";
import "./style.scss";

export default class HostPage extends Component {
  render() {
    return (
      <div className="hostpage">
        <div className="hostLink">
          <a className="" href="../../images/proxy109.apk" download>
          <i class="fas fa-download" style={{marginRight:"0.5rem"}}></i>

                Download App <br/> (For Proxy)
          </a>
         <span> proxy.apk</span>
        </div>
        <div className="hostLink">
          <a className="" href="../../images/noproxy109.apk" download>
          <i class="fas fa-download" style={{marginRight:"0.5rem"}}></i>

          Download App <br/> (For Open Network)
          </a>
          <span> noproxy.apk</span>
        </div>
        
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/HostPage/index.js